<template>
  <div>
    <a-row type="flex" justify="end" class="mb-2">
      <a-button :disabled="!hasActiveFilters" @click="clearAllFilters">
        <template #icon><clear-outlined /></template>
        Limpiar filtros
      </a-button>
    </a-row>

    <div class="scroll-top" ref="scrollTop" @scroll="syncScrollTop">
      <div
        class="scroll-content"
        :style="{ width: tableScrollWidth + 'px' }"
      ></div>
    </div>

    <div class="scroll-bottom" ref="scrollBottom">
      <a-table
        :dataSource="tableData"
        :columns="tableColumns"
        :pagination="paginationProps"
        @change="changeCurrentPage"
        :loading="loadingData"
        :scroll="{ x: 'max-content' }"
      >
        <template #dateFilter="{ column, confirm, clearFilters }">
          <a-form
            style="padding: 8px"
            name="form"
            layout="vertical"
            ref="formRef"
            :model="filterValues"
            :rules="rules"
          >
            <a-form-item has-feedback :name="column.dataIndex">
              <a-range-picker
                v-model:value="filterValues[column.key]"
                :value-format="'YYYY-MM-DD'"
                :format="['DD-MM-YYYY', 'DD-MM-YYYY']"
              />
            </a-form-item>

            <a-button
              type="primary"
              size="small"
              style="width: 90px; margin-right: 8px"
              @click="
                handleSearch(
                  column.dataIndex,
                  filterValues[column.key],
                  confirm
                )
              "
            >
              <template #icon><search-outlined /></template>
              Buscar
            </a-button>

            <a-button
              size="small"
              style="width: 90px"
              @click="handleColumnReset(column.dataIndex, clearFilters)"
            >
              Limpiar
            </a-button>
          </a-form>
        </template>

        <!-- Modal de filtro de input -->
        <template #filterDropdown="{ column, confirm, clearFilters }">
          <div style="padding: 8px">
            <a-form
              name="form"
              layout="vertical"
              ref="formRef"
              :model="filterValues"
              :rules="rules"
            >
              <a-form-item has-feedback :name="column.dataIndex">
                <a-input
                  v-model:value="filterValues[column.key]"
                  @keyup="formatRuts"
                  :maxlength="
                    column.dataIndex == 'employeeRut' ||
                    column.dataIndex == 'companyRut'
                      ? 12
                      : 40
                  "
                  :placeholder="`Buscar por ${column.title}`"
                  @pressEnter="
                    handleSearch(
                      column.dataIndex,
                      filterValues[column.key],
                      confirm
                    )
                  "
                  style="width: 188px; margin-bottom: 8px; display: block"
                />
              </a-form-item>

              <a-button
                type="primary"
                size="small"
                style="width: 90px; margin-right: 8px"
                @click="
                  handleSearch(
                    column.dataIndex,
                    filterValues[column.key],
                    confirm
                  )
                "
              >
                <template #icon><search-outlined /></template>
                Buscar
              </a-button>

              <a-button
                size="small"
                style="width: 90px"
                @click="handleColumnReset(column.dataIndex, clearFilters)"
              >
                Limpiar
              </a-button>
            </a-form>
          </div>
        </template>

        <!-- Modal de filtro de input -->
        <template #filterCompanies="{ column, confirm, clearFilters }">
          <div style="padding: 8px; width: 300px">
            <a-select
              v-model:value="selectedCompanies"
              :options="companies"
              mode="multiple"
              show-search
              :filterOption="true"
              optionFilterProp="label"
              placeholder="Buscar por razón social"
              style="width: 100%"
              size="middle"
            >
              <template #dropdownRender="{ menuNode: menu }">
                <v-nodes :vnodes="menu" />
                <div
                  style="
                    border-top: 1px solid #f0f0f0;
                    display: flex;
                    justify-content: space-between;
                  "
                  class="p-2"
                  @mousedown="(e) => e.preventDefault()"
                >
                  <a-button
                    type="primary"
                    size="small"
                    style="width: 90px; margin-right: 8px"
                    @click="
                      handleSearch(
                        column.dataIndex,
                        selectedCompanies.join(','),
                        confirm
                      )
                    "
                  >
                    Buscar
                  </a-button>

                  <a-button
                    size="small"
                    style="width: 90px"
                    @click="handleColumnReset(column.dataIndex, clearFilters)"
                  >
                    Limpiar
                  </a-button>
                </div>
              </template>
            </a-select>
            <div
              class="mt-4 p-2"
              style="
                border-top: 1px solid #f0f0f0;
                display: flex;
                justify-content: space-between;
              "
            >
              <a-button
                type="primary"
                size="small"
                style="width: 90px; margin-right: 8px"
                @click="
                  handleSearch(
                    column.dataIndex,
                    selectedCompanies.join(','),
                    confirm
                  )
                "
              >
                Buscar
              </a-button>

              <a-button
                size="small"
                style="width: 90px"
                @click="handleColumnReset(column.dataIndex, clearFilters)"
              >
                Limpiar
              </a-button>
            </div>
          </div>
        </template>

        <template #filterBrokers="{ column, confirm, clearFilters }">
          <div style="padding: 8px; width: 300px">
            <a-select
              v-model:value="selectedBrokers"
              :options="brokers"
              mode="multiple"
              show-search
              :filterOption="true"
              optionFilterProp="label"
              placeholder="Buscar por ejecutivo"
              style="width: 100%"
              size="middle"
            >
              <template #dropdownRender="{ menuNode: menu }">
                <v-nodes :vnodes="menu" />
                <div
                  style="
                    border-top: 1px solid #f0f0f0;
                    display: flex;
                    justify-content: space-between;
                  "
                  class="p-2"
                  @mousedown="(e) => e.preventDefault()"
                >
                  <a-button
                    type="primary"
                    size="small"
                    style="width: 90px; margin-right: 8px"
                    @click="
                      handleSearch(
                        column.dataIndex,
                        selectedBrokers.join(','),
                        confirm
                      )
                    "
                  >
                    Buscar
                  </a-button>

                  <a-button
                    size="small"
                    style="width: 90px"
                    @click="handleColumnReset(column.dataIndex, clearFilters)"
                  >
                    Limpiar
                  </a-button>
                </div>
              </template>
            </a-select>
            <div
              class="mt-4 p-2"
              style="
                border-top: 1px solid #f0f0f0;
                display: flex;
                justify-content: space-between;
              "
            >
              <a-button
                type="primary"
                size="small"
                style="width: 90px; margin-right: 8px"
                @click="
                  handleSearch(
                    column.dataIndex,
                    selectedBrokers.join(','),
                    confirm
                  )
                "
              >
                Buscar
              </a-button>

              <a-button
                size="small"
                style="width: 90px"
                @click="handleColumnReset(column.dataIndex, clearFilters)"
              >
                Limpiar
              </a-button>
            </div>
          </div>
        </template>

        <!-- Filtros para estados -->

        <template #filterStates="{ confirm, column, clearFilters }">
          <div style="padding: 8px; width: 300px">
            <a-checkbox-group v-model:value="statesSelection">
              <a-row>
                <a-col
                  :span="24"
                  v-for="(state, index) in statesOptions"
                  :key="index"
                >
                  <a-checkbox :value="state.value">
                    {{ state.label }}
                  </a-checkbox>
                </a-col>
              </a-row>
            </a-checkbox-group>

            <a-checkbox
              v-if="ticketType == 'Alta'"
              v-model:checked="requestedFile"
            >
              En resolicitud
            </a-checkbox>

            <div
              class="mt-4 p-2"
              style="
                border-top: 1px solid #f0f0f0;
                display: flex;
                justify-content: space-between;
              "
            >
              <a-button
                type="primary"
                size="small"
                style="width: 90px; margin-right: 8px"
                @click="
                  handleSearch(
                    column.dataIndex,
                    statesSelection.join(','),
                    confirm
                  )
                "
              >
                <template #icon><search-outlined /></template>
                Buscar
              </a-button>

              <a-button
                size="small"
                style="width: 90px"
                @click="handleColumnReset(column.dataIndex, clearFilters)"
              >
                Limpiar
              </a-button>
            </div>
          </div>
        </template>

        <!-- Tag de los estados -->
        <template #tag="{ text: state }">
          <tag v-if="state == 'requested'" color="warning">EN RESOLICITUD</tag>
          <tag v-else :stateId="state.id" :state="state" type="ticket" />
        </template>

        <!-- Icono de filtrado de lupa -->
        <template #filterIcon="{ column }">
          <search-outlined
            :style="{
              color:
                searchValue[column.dataIndex] === undefined ||
                searchValue[column.dataIndex] === '' ||
                (Array.isArray(filterValues[column.dataIndex]) &&
                  filterValues[column.dataIndex].length === 0)
                  ? undefined
                  : '#2521E5'
            }"
          />
        </template>

        <!-- Icono de filtrado para seleccion por checkbox -->
        <template #filterIconState="{ column }">
          <filter-outlined
            :style="{
              color: iconStateFiltered(column.dataIndex) ? undefined : '#2521E5'
            }"
          />
          <!-- searchValue[column.dataIndex] === undefined || searchValue[column.dataIndex] === '' -->
        </template>

        <!-- Tag de los estados -->
        <template #details="{ text }">
          <a-tooltip :color="'#05045D'">
            <template #title>Ver más</template>
            <router-link
              :to="{
                name:
                  ticketType == 'Alta'
                    ? 'AltasDetalle'
                    : ticketType == 'Baja'
                      ? 'BajaDetail'
                      : ticketType == 'Modificacion'
                        ? 'DetalleModificaciones'
                        : ticketType == 'Bajas de cargas'
                          ? 'BajaCargasDetalle'
                          : 'AltaCargasDetalle',
                params: { id: text }
              }"
            >
              <eye-outlined />
            </router-link>
          </a-tooltip>

          <a-tooltip
            :color="'#05045D'"
            @click="openModal(text)"
            class="ml-3 request_icon"
            v-if="
              tableData.find((x) => x.id == text)?.state?.id == 1 &&
              ticketType == 'Alta'
            "
          >
            <template #title>Reenviar formulario</template>
            <mail-outlined />
          </a-tooltip>
        </template>
      </a-table>

      <!-- Modal de resolicitud -->
      <a-modal
        v-model:visible="requestModalVisible"
        title="Reenviar Formulario Incorporación"
        :closable="!loadingModal"
        :maskClosable="!loadingModal"
      >
        <b>Correo eléctronico actual: {{ foundMail }}</b>

        <a-form
          name="form"
          layout="vertical"
          ref="requestFormRef"
          :model="formState"
          :rules="rules"
        >
          <a-form-item
            class="mt-3"
            name="email"
            label="Actualizar correo electrónico del colaborador (opcional)"
          >
            <a-input
              v-model:value="formState.email"
              placeholder="Ingresa nuevo correo electrónico"
              :maxlength="35"
            />
          </a-form-item>
        </a-form>

        <template #footer>
          <a-button key="back" @click="handleCancel" :disabled="loadingModal">
            Cancelar
          </a-button>
          <a-button key="submit" @click="requestFile" :loading="loadingModal">
            Reenviar
          </a-button>
        </template>
      </a-modal>
    </div>
  </div>
</template>

<script>
import {
  computed,
  onMounted,
  reactive,
  ref,
  watch,
  watchEffect,
  nextTick,
  onBeforeUnmount
} from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { getTicketStates } from '../../network';
import { message } from 'ant-design-vue';

import moment from 'moment';
import {
  SearchOutlined,
  FilterOutlined,
  EyeOutlined,
  MailOutlined,
  ClearOutlined
} from '@ant-design/icons-vue';
import { useStore } from 'vuex';
import {
  FETCH_TABLE_TICKETS,
  FETCH_TABLE_TICKETS_V2,
  GETTER_TICKET_TABLE_ROWS,
  GETTER_TICKET_TABLE_TOTAL_PAGES,
  GETTER_TICKET_TABLE_ITEMS_PER_PAGE,
  GETTER_TICKET_TABLE_CURRENT_PAGE,
  GET_ALL_COMPANIES,
  FETCH_ALL_BROKERS,
  GET_ALL_BROKERS,
  FETCH_ALL_COMPANIES,
  TICKET_RESEND_FORM_INCORPORATION
} from '../../store/types';
import rutHelper from '../../utils/Ruts';
import tag from '../tags.vue';

export default {
  name: 'TicketsTable',
  components: {
    'search-outlined': SearchOutlined,
    'filter-outlined': FilterOutlined,
    'eye-outlined': EyeOutlined,
    'mail-outlined': MailOutlined,
    'clear-outlined': ClearOutlined,
    tag,
    VNodes: (_, { attrs }) => {
      return attrs.vnodes;
    }
  },
  props: {
    type: String,
    dates: Object,
    v2Types: {
      type: Array,
      default: () => []
    }
  },
  setup(props) {
    // Tipo de ticket
    const ticketType = computed(() => {
      switch (route.name) {
        case 'Altas':
          return 'Alta';
        case 'AltasCargas':
          return 'Altas de cargas';
        case 'Bajas':
          return 'Baja';
        case 'BajasCargas':
          return 'Bajas de cargas';
        case 'Modificaciones':
          return 'Modificacion';
        case 'Transfers':
          return 'Traspaso';
        default:
          break;
      }
      return '';
    });

    const scrollTop = ref(null);
    const scrollBottom = ref(null);
    const tableScrollWidth = ref(0);

    let ro = null;

    /*
    Tabla para la carga de resultados segun filtro que hace el usuario, paginación y filtro por fechas
    TODO: (1)[X] Cargar vue routes para las operaciones de las rutas
    TODO: (2)[X] Cualquier cambio que se haga a la url tener una manera de estar atentos a ello
    TODO: (3)[X] Cuando se haga un filtro, paginación nueva o filtro de fecha, redireccionar la página con el nuevo url
    TODO: (4)[X] Al momento de que se cargue la página, obtener los valores de la url para ponerlos en los filtros asi para tener un control de lo que se busco
    TODO: (5)[X] Filtros de las columnas con las rutas
    */

    // * VUEX
    const store = useStore();

    // * Vue router ### (1) ###
    const route = useRoute();
    const router = useRouter();
    const formRef = ref();
    const validError = ref();

    // * Estar atento a cualquier cambio de la url ### (2) ###
    const loadingData = ref(false); // efecto de carga de la tabla cuando encuentre la data
    watchEffect(async (onCleanUp) => {
      try {
        if (!ticketType.value) return;
        loadingData.value = true;
        const ac = new AbortController();
        const signal = ac.signal;
        onCleanUp(() => ac.abort());
        const queryParams = route.fullPath.split('?')[1] || '';
        const useV2 = props.v2Types.includes(ticketType.value);
        const action = useV2 ? FETCH_TABLE_TICKETS_V2 : FETCH_TABLE_TICKETS;
        await store.dispatch(action, {
          payload: `type=${ticketType.value}&${queryParams}`,
          signal
        });
        loadingData.value = false;
      } catch (error) {
        loadingData.value = false;
        console.error(error);
      }
    });
    const getTableBody = () => {
      return (
        scrollBottom.value?.querySelector('.ant-table-body') ||
        scrollBottom.value?.querySelector('.ant-table-content') ||
        scrollBottom.value?.querySelector('.ant-table-container')
      );
    };

    const updateScrollWidth = () => {
      const tableBody = getTableBody();
      if (!tableBody) return;

      tableScrollWidth.value = Math.max(
        tableBody.scrollWidth,
        tableBody.clientWidth
      );
    };

    const syncScrollBottom = () => {
      const tableBody = getTableBody();
      if (!tableBody || !scrollTop.value) return;

      scrollTop.value.scrollLeft = tableBody.scrollLeft;
    };

    const syncScrollTop = () => {
      const tableBody = getTableBody();
      if (!tableBody || !scrollTop.value) return;

      tableBody.scrollLeft = scrollTop.value.scrollLeft;
    };

    // * Redireccion al momento de hacer un filtro ### (3) ###
    const filterValues = ref({
      createdAt: []
    }); // Objeto que guarda los valores de los filtros
    const searchValue = ref({
      createdAt: []
    }); // Objeto que guarda los valores de los cuales se hace la busqueda por filtro

    const deleteParamForRedirection = (key) => {
      delete searchValue.value[key];
    };

    const addParamForRedirection = (key, param) => {
      if (key == 'companyRut' || key == 'employeeRut') {
        searchValue.value[key] = rutHelper.normalizeRut(param);
      } else if (key == 'createdAt') {
        searchValue.value['startDate'] = param[0];
        searchValue.value['endDate'] = param[1];
      } else {
        searchValue.value[key] = param;
      }

      if (key != 'page') {
        searchValue.value['page'] = 1;
      }
    };

    const filterRedirectionNewParam = () => {
      formRef.value
        .validate()
        .then(() => {
          router.replace({
            name: route.name,
            query: searchValue.value
          });
        })
        .catch((error) => {
          console.log('error', error);
          validError.value = error;
        });
    };

    const formatRuts = () => {
      if (filterValues.value['employeeRut']) {
        filterValues.value['employeeRut'] = rutHelper.formatRut(
          filterValues.value['employeeRut']
        );
      }
      if (filterValues.value['companyRut']) {
        filterValues.value['companyRut'] = rutHelper.formatRut(
          filterValues.value['companyRut']
        );
      }
    };

    // Redireccion reseteando o sacando un parametro
    const filterRedirectionResetColumn = (key) => {
      if (key === 'createdAt') {
        delete searchValue.value['startDate'];
        delete searchValue.value['endDate'];
      }
      delete searchValue.value[key];

      router.replace({
        name: route.name,
        query: searchValue.value
      });
    };

    // * Filtros de las columnas con las rutas cambiantes ### (5) ###
    // Tabla
    const tableColumns = [
      {
        width: 100,
        title: 'Id',
        dataIndex: 'id',
        key: 'id',
        slots: {
          filterDropdown: 'filterDropdown',
          filterIcon: 'filterIcon'
        }
      },
      {
        width: 150,
        title: 'Holding',
        dataIndex: 'holding',
        key: 'holding',
        slots: {
          filterDropdown: 'filterDropdown',
          filterIcon: 'filterIcon'
        }
      },
      {
        width: 150,
        title: 'Subholding',
        dataIndex: 'subHolding',
        key: 'subHolding',
        slots: {
          filterDropdown: 'filterDropdown',
          filterIcon: 'filterIcon'
        }
      },
      {
        width: 150,
        title: 'Razón social',
        dataIndex: 'companyId',
        key: 'companyId',
        slots: {
          filterDropdown: 'filterCompanies',
          filterIcon: 'filterIcon'
        }
      },
      {
        width: 150,
        title: 'RUT empresa',
        dataIndex: 'companyRut',
        key: 'companyRut',
        slots: {
          filterDropdown: 'filterDropdown',
          filterIcon: 'filterIcon'
        }
      },
      {
        width: 100,
        title: 'Póliza',
        dataIndex: 'policies',
        key: 'policies',
        slots: {
          filterDropdown: 'filterDropdown',
          filterIcon: 'filterIcon'
        }
      },
      {
        width: 150,
        title: 'Grupo',
        dataIndex: 'groupCompanies',
        key: 'groupCompanies',
        slots: {
          filterDropdown: 'filterDropdown',
          filterIcon: 'filterIcon'
        }
      },
      {
        width: 200,
        title: 'Nombre',
        dataIndex: 'employeeName',
        key: 'employeeName',
        slots: {
          filterDropdown: 'filterDropdown',
          filterIcon: 'filterIcon'
        }
      },
      {
        width: 150,
        title: 'RUT empleado',
        dataIndex: 'employeeRut',
        key: 'employeeRut',
        slots: {
          filterDropdown: 'filterDropdown',
          filterIcon: 'filterIcon'
        }
      },
      {
        width: 175,
        title: 'Estado',
        dataIndex: 'state',
        key: 'state',
        slots: {
          customRender: 'tag',
          filterDropdown: 'filterStates',
          filterIcon: 'filterIconState'
        }
      },
      {
        width: 150,
        title: 'Fecha estado',
        dataIndex: 'stateDate',
        key: 'stateDate'
      },
      {
        width: 150,
        title: 'Fecha creación',
        dataIndex: 'createdAt',
        key: 'createdAt',
        slots: {
          filterDropdown: 'dateFilter',
          filterIcon: 'filterIcon'
        }
      },
      {
        width: 150,
        title: 'Ejecutivo',
        dataIndex: 'brokerId',
        key: 'brokerId',
        slots: {
          filterDropdown: 'filterBrokers',
          filterIcon: 'filterIconState'
        }
      },
      {
        title: 'Acción',
        dataIndex: 'id',
        key: 'id',
        width: 95,
        slots: {
          customRender: 'details'
        },
        fixed: 'right',
        align: 'center'
      }
    ];

    const tableData = computed(() => {
      return store.getters[GETTER_TICKET_TABLE_ROWS].map((obj) => {
        return {
          id: obj.id,
          key: obj.id,
          holding: obj.holding,
          companyId: obj.company.name,
          companyRut: rutHelper.formatRut(obj.company.rut),
          email: obj.employee.email,
          subHolding: obj.subHolding,
          employeeName: obj.employee.name,
          employeeRut: rutHelper.formatRut(obj.employee.rut),
          state: obj.isRequesting == false ? obj.state : 'requested',
          stateDate: moment(obj.state.stateDate).format('DD/MM/YYYY'),
          createdAt: moment(obj.createdAt).format('DD/MM/YYYY'),
          brokerId: obj.broker?.name,
          policies: obj.policies?.join(', ') || '',
          groupCompanies: obj.groupCompanies?.join(', ') || ''
        };
      });
    });

    const total = computed(() => {
      return store.getters[GETTER_TICKET_TABLE_TOTAL_PAGES];
    });

    // Items por página
    const itemsPerPage = computed(() => {
      return store.getters[GETTER_TICKET_TABLE_ITEMS_PER_PAGE];
    });

    // Pagina en la que nos encontramos
    const currentPage = computed(() => {
      return store.getters[GETTER_TICKET_TABLE_CURRENT_PAGE];
    });

    const paginationProps = computed(() => ({
      total: total.value,
      pageSize: itemsPerPage.value,
      current: Number(currentPage.value)
    }));

    const changeCurrentPage = (page) => {
      addParamForRedirection('page', page.current);
      filterRedirectionNewParam();
    };

    // Seleccion de estados
    const statesSelection = ref([]);

    const filteredStates = ref([]);

    const statesOptions = computed(() => {
      return filteredStates.value.map((state) => ({
        label: state.fullTag || state.tag,
        value: state.id
      }));
    });

    // Busqueda por columna
    const handleSearch = (column, value, confirm) => {
      formRef.value.validate().then(() => {
        if (column === 'state') {
          const hasStates = value !== '' && value !== undefined;

          if (requestedFile.value === true) {
            addParamForRedirection('isRequesting', true);
          } else {
            deleteParamForRedirection('isRequesting');
          }

          if (!hasStates) {
            deleteParamForRedirection('state');
          }
        }

        if (value !== '' && value !== undefined) {
          addParamForRedirection(column, value);
        }

        filterRedirectionNewParam();
        confirm();
      });

      if (value === undefined || value === '') {
        formRef.value.clearValidate();
      }
    };

    const iconStateFiltered = (column) => {
      return (
        searchValue.value[column] === undefined && requestedFile.value === false
      );
    };

    // Limpiar columna
    const handleColumnReset = (column, resetConfirm) => {
      filterRedirectionResetColumn(column);
      resetConfirm();
      delete filterValues.value[column];
      if (column == 'employeeRut' || column == 'companyRut') {
        formRef.value.resetFields();
        formRef.value.clearValidate();
      }

      if (column === 'state') {
        statesSelection.value = [];
        requestedFile.value = false;
        filterRedirectionResetColumn('isRequesting');
      }

      if (column === 'companyId') {
        selectedCompanies.value = [];
      }

      if (column === 'brokerId') {
        selectedBrokers.value = [];
      }

      if (column === 'createdAt') {
        filterValues.value[column] = [];
      }
    };

    // Clear all column filters
    const hasActiveFilters = computed(() =>
      Object.keys(route.query).some((key) => key !== 'page')
    );

    const clearAllFilters = () => {
      Object.keys(filterValues.value).forEach((key) => {
        delete filterValues.value[key];
      });
      filterValues.value.createdAt = [];
      Object.keys(searchValue.value).forEach((key) => {
        delete searchValue.value[key];
      });
      searchValue.value.createdAt = [];

      statesSelection.value = [];
      selectedCompanies.value = [];
      selectedBrokers.value = [];
      requestedFile.value = false;
      formRef.value?.clearValidate();

      router.replace({ name: route.name, query: {} });
    };

    // Busqueda por estado
    const stateTicketSearchFilter = (states, confirm) => {
      addParamForRedirection('state', states.join(','));
      filterRedirectionNewParam();
      confirm();
    };

    // * Selector por compania
    /*
    Como el selector de compania tiene que ver en conjunto a la parte del dashboard donde el usuario tiene que selecccionar que
    companias van a aparecer filtradas antes de entrar, va a tener una logica dintinta a las demas selecciones y va a ser de este estilo
    */
    const getCompaniesList = async () => {
      try {
        store.dispatch(FETCH_ALL_COMPANIES);
      } catch (error) {
        console.log(error);
      }
    };

    const selectedCompanies = ref([]);
    const getBrokersList = async () => {
      try {
        store.dispatch(FETCH_ALL_BROKERS);
      } catch (error) {
        console.log(error);
      }
    };

    const companies = computed(() => {
      return store.getters[GET_ALL_COMPANIES].map((obj) => {
        return {
          value: obj.id,
          label: obj.businessName
        };
      });
    });

    const selectedBrokers = ref([]);
    const brokers = computed(() => {
      return store.getters[GET_ALL_BROKERS].map((obj) => {
        return {
          value: obj.id,
          label: obj.name
        };
      });
    });

    // * Filtro de resolcitud
    const requestedFile = ref(false);

    // * Filtro de fecha desde afuera
    watch(
      () => props.dates,
      (newVal) => {
        if (newVal[0] != undefined && newVal[1] != undefined) {
          addParamForRedirection('startDate', newVal[0]);
          addParamForRedirection('endDate', newVal[1]);
        } else {
          deleteParamForRedirection('startDate');
          deleteParamForRedirection('endDate');
        }

        filterRedirectionNewParam();
      }
    );

    watch(filterValues.value, (value) => {
      if (value.employeeRut == '') {
        formRef.value.clearValidate();
      }
      if (value.companyRut == '') {
        formRef.value.clearValidate();
      }
    });

    // * Modal de resolicitud
    const requestFormRef = ref();
    const requestModalVisible = ref(false);
    const foundMail = ref('');
    const ticketIdFound = ref();
    const loadingModal = ref(false);
    const openModal = (id) => {
      ticketIdFound.value = id;
      requestModalVisible.value = true;
      foundMail.value = tableData.value.find((x) => x.id == id).email;
    };

    const formState = reactive({
      email: ''
    });

    const validateEmail = (mail) => {
      return String(mail)
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
    };

    const checkEmail = async (_, value) => {
      if (!value || value == '') {
        return Promise.resolve();
      }
      if (validateEmail(value)) {
        return Promise.resolve();
      }
      return Promise.reject('Correo inválido');
    };
    const checkRut = async (_, value) => {
      if (!value) {
        return;
      }
      if (!rutHelper.validateRut(value)) {
        return Promise.reject('RUT no válido');
      }
      return Promise.resolve();
    };
    const checkId = async (_, value) => {
      if (!value) {
        return Promise.resolve();
      }
      if (!/^[1-9]\d*$/.test(String(value).trim())) {
        return Promise.reject('Id no válido');
      }
      return Promise.resolve();
    };

    const rules = {
      id: [
        {
          required: false,
          validator: checkId,
          trigger: 'change'
        }
      ],
      email: [
        {
          required: true,
          validator: checkEmail,
          trigger: 'change'
        }
      ],
      employeeRut: [
        {
          required: false,
          validator: checkRut,
          trigger: 'change'
        }
      ],
      companyRut: [
        {
          required: false,
          validator: checkRut,
          trigger: 'change'
        }
      ]
    };

    const handleCancel = () => {
      requestModalVisible.value = false;
    };

    const requestFile = () => {
      loadingModal.value = true;
      requestFormRef.value
        .validate()
        .then((resp) => {
          const payload = {};
          if (resp.email != '') {
            payload['email'] = resp.email;
          }

          store
            .dispatch(TICKET_RESEND_FORM_INCORPORATION, {
              id: ticketIdFound.value,
              payload
            })
            .then(() => {
              loadingModal.value = false;
              message.success('Resolicitado');
              requestModalVisible.value = false;
            })
            .catch(() => {
              loadingModal.value = false;
              message.error('Ocurrió un error, vuelve a intentarlo más tarde');
              requestModalVisible.value = false;
            });
        })
        .catch(() => {
          loadingModal.value = false;
          requestModalVisible.value = false;
        });
    };

    // * Recarga de página, obtencion de los valores de la url a filtros ### (4) ###
    onMounted(() => {
      // Voy a obtener la lista de companias para el selector mismo
      getCompaniesList();
      getBrokersList();

      getTicketStates().then((response) => {
        filteredStates.value = response.data.filter((s) =>
          [1, 7, 8, 3, 4].includes(s.id)
        );
      });

      // Al momento de cargar la página, voy a ver que parametros vienen, con eso voy a dejar los valores de cada uno de los filtros realizados ahi
      const keys = Object.keys(route.query);

      keys.forEach((element) => {
        if (!['startDate', 'endDate'].includes(element)) {
          filterValues.value[element] = route.query[element]; // Le paso valor al los inputs para que muestre que es lo que busco anteriormente
          searchValue.value[element] = route.query[element]; // Le paso valor al objeto de la busqueda en caso de hacer otra consulta
        }

        // en caso de que el filtro que venga sea 'State', voy a dejar selecciadas las casillas checkbox
        if (element === 'state') {
          statesSelection.value.push(
            ...route.query[element].split(',').map((e) => parseInt(e))
          );
        }

        if (element === 'startDate') {
          filterValues.value['createdAt'][0] = moment(
            route.query[element],
            'YYYY-MM-DD'
          );
        }

        if (element === 'endDate') {
          filterValues.value['createdAt'][1] = moment(
            route.query[element],
            'YYYY-MM-DD'
          );
        }

        if (element === 'companyId') {
          selectedCompanies.value.push(
            ...route.query[element].split(',').map((e) => parseInt(e))
          );
        }

        if (element === 'brokerId') {
          selectedBrokers.value.push(
            ...route.query[element].split(',').map((e) => parseInt(e))
          );
        }

        // En caso de que este en resolicitud
        if (element === 'isRequesting') {
          requestedFile.value = route.query[element] === 'true';
        }
      });

      setTimeout(async () => {
        await nextTick();

        updateScrollWidth();

        const tableBody = getTableBody();
        if (!tableBody) return;

        tableBody.addEventListener('scroll', syncScrollBottom);

        ro = new ResizeObserver(() => {
          updateScrollWidth();
        });
        ro.observe(tableBody);
      }, 50);
    });

    onBeforeUnmount(() => {
      const tableBody = getTableBody();

      if (tableBody) {
        tableBody.removeEventListener('scroll', syncScrollBottom);
      }

      if (ro && tableBody) {
        ro.unobserve(tableBody);
      }

      ro = null;
    });

    return {
      filterValues,
      searchValue,
      tableColumns,
      tableData,
      handleColumnReset,
      handleSearch,
      filterRedirectionNewParam,
      paginationProps,
      changeCurrentPage,
      statesSelection,
      statesOptions,
      stateTicketSearchFilter,
      hasActiveFilters,
      clearAllFilters,
      loadingData,
      companies,
      selectedCompanies,
      ticketType,
      requestedFile,
      requestModalVisible,
      openModal,
      foundMail,
      requestFormRef,
      formState,
      rules,
      handleCancel,
      requestFile,
      loadingModal,
      rutHelper,
      formatRuts,
      formRef,
      validError,
      iconStateFiltered,
      brokers,
      selectedBrokers,
      scrollTop,
      scrollBottom,
      tableScrollWidth,
      syncScrollTop,
      updateScrollWidth,
      syncScrollBottom
    };
  }
};
</script>

<style scoped>
.request_icon {
  color: #2521e5;
}

.scroll-top {
  height: 18px;
  margin-bottom: 6px;
  overflow-x: scroll;
  overflow-y: hidden;
  border-radius: 6px;
}

.scroll-content {
  height: 1px;
}
</style>
